<p-dropdown
  [options]="sites"
  [(ngModel)]="selectedSite"
  placeholder="Sélectionner un établissement"
  id="etablissement"
  name="etablissement"
  class="dropdown-etablissement"
  scrollHeight="400px"
  (onChange)="siteChanged()"
  [filter]="true"
  [filterFields]="['SiteNom', 'EtablissementNom']"
  emptyFilterMessage="Aucun site trouvé"
  [readonly]="siteIsLocked"
  *ngIf="etablissementsLoaded"
>
  <ng-template pTemplate="selectedItem">
    <table *ngIf="selectedSite && !selectedSite.SiteNom" class="table-etablissement-item-value">
      <tr>
        <td class="td-etablissement-item-value"><img src="{{ selectedSite.LogoUrl }}" class="selected-item-img-etablissement" /></td>
      </tr>
    </table>
    <table *ngIf="selectedSite && selectedSite.SiteNom" class="table-etablissement-item-value" title="{{ selectedSite ? selectedSite.SiteNom : '' }}">
      <tr>
        <td class="td-etablissement-item-value" style="width: 30%"><img src="{{ selectedSite.LogoUrl }}" class="selected-item-img-etablissement" /></td>
        <td class="td-etablissement-item-value" style="width: 70%">{{ selectedSite.SiteNom }}</td>
      </tr>
    </table>
  </ng-template>
  <ng-template let-site pTemplate="item">
    <table>
      <tr>
        <td class="td-etablissement-img" style="width: 30%"><img src="{{ site.LogoUrl }}" class="etablissement-item-img" /></td>
        <td class="td-etablissement-nom" style="width: 70%">{{ site.EtablissementNom }}{{ site.SiteNom ? ' - ' + site.SiteNom : '' }}</td>
      </tr>
    </table>
  </ng-template>
</p-dropdown>
